import React, { useState, useEffect } from 'react';
import api from './api';
import Connexion from './Connexion';
import Veille from './Veille';
import Comparatif from './Comparatif';

export default function App() {
  const [utilisateur, setUtilisateur] = useState(null);
  const [charge, setCharge] = useState(false);
  const [onglet, setOnglet] = useState('veille');

  useEffect(() => {
    if (!localStorage.getItem('a97vin-token')) { setCharge(true); return; }
    api.get('/auth/moi')
      .then((r) => setUtilisateur(r.data.utilisateur))
      .catch(() => localStorage.removeItem('a97vin-token'))
      .finally(() => setCharge(true));
  }, []);

  const deconnecter = () => { localStorage.removeItem('a97vin-token'); setUtilisateur(null); };

  if (!charge) return <div className="attente">Chargement…</div>;
  if (!utilisateur) return <Connexion onConnecte={setUtilisateur} />;

  return (
    <div className="appli">
      <header>
        <span className="marque logotype"><span className="a">A</span><span className="n">97</span><span className="app">VIN</span></span>
        <span className="pousse" />
        <span className="qui">{utilisateur.nom || utilisateur.identifiant}</span>
        <button className="lien" onClick={deconnecter}>Déconnexion</button>
      </header>
      <nav className="onglets">
        <button className={onglet === 'veille' ? 'actif' : ''} onClick={() => setOnglet('veille')}>📋 Relevés</button>
        <button className={onglet === 'comparatif' ? 'actif' : ''} onClick={() => setOnglet('comparatif')}>⚖️ Comparatif</button>
      </nav>
      <main>
        {onglet === 'veille' ? <Veille utilisateur={utilisateur} /> : <Comparatif />}
      </main>
    </div>
  );
}
